module.exports = __webpack_public_path__ + "media/svg-new/audio-4dc5e65d.svg";